'use client';

import { contentPipeline } from '@doist/content-system';
import { Button, Modal } from '@doist/marketist';
import { useTranslation } from 'app/i18n/client';
import { addProtocol } from 'app/services/contentful/add-protocol-to-url';
import { useDialogState } from 'ariakit/dialog';
import { ArticlePageHeader } from 'components/article-page-header/article-page-header';
import { CTFRichText } from 'components/blog-posts/ctf-rich-text/ctf-rich-text';
import { useLocale } from 'next-intl';
import { syntheticPageView } from 'services/analytics';
import type { Integration } from 'app/[locale]/integrations/types';
export type IntegrationPageHeaderProps = {
  integration: Integration;
};
const transform = contentPipeline({
  source: 'contentful'
});
function IntegrationPageHeader({
  integration
}: IntegrationPageHeaderProps) {
  const locale = useLocale();
  const {
    t
  } = useTranslation(locale, 'integrations');
  const dialog = useDialogState();
  const commonContent = integration.fields.commonContent?.fields;
  if (!commonContent) return null;
  const illustrationSrc = addProtocol(commonContent.appLogo?.fields.file?.url || '');
  return <>
            <ArticlePageHeader title={integration.fields.title} description={commonContent.tagline} backButton={{
      text: t('allIntegrations'),
      href: '/integrations'
    }} thumbnail={{
      src: `${illustrationSrc}?w=270`,
      viewType: 'icon'
    }} buttons={[integration.fields.installUrl ? <Button key="integration-install" data-gtm-id="integration_install" href={integration.fields.installUrl} target="_blank">
                            {integration.fields.buttonText || t('add')}
                        </Button> : integration.fields.howToInstall ? <Button key="integration-how-to" onClick={() => {
      syntheticPageView(`${window.location.href}/how-to`, integration.fields.title, window.location.toString());
      dialog.show();
    }} tabIndex={-1}>
                            {integration.fields.buttonText || t('add')}
                        </Button> : null, <Button key="integration-learn-more" data-gtm-id="integration_learn_more" href={integration.fields.commonContent?.fields.learnMoreButton} target="_blank" variant="secondary">
                        {t('more')}
                    </Button>]} width="base" data-sentry-element="ArticlePageHeader" data-sentry-source-file="integration-page-header.tsx" />

            {integration.fields.howToInstall ? <Modal dialog={dialog} title={t('howToInstall', {
      name: integration.fields.title
    })} closeLabel={t('close', {
      ns: 'common'
    })}>
                    <CTFRichText document={transform(integration.fields.howToInstall)} />
                </Modal> : null}
        </>;
}
export { IntegrationPageHeader };